import React, { useEffect, useState } from 'react'
import { lmsAdmin } from '../api'
import { RESULT_RULES, RESULT_RULE_HELP, RESULT_RULE_TITLE, RESULT_RULE_UNAVAILABLE } from '../result-rule'

// "Which result counts when a learner launches again" for one course on one
// connection. Saves on its own: PATCH /admin/lms/connections/{id}/courses/{nodeId}
// {result_rule}, apart from the score setting. `result_rule` null: the service
// cannot read it yet (disabled, with the reason). `canChange` is the LMS admin
// scope's (the service checks it too).
export const CourseResultRule = ({ connection, nodeId, mapping, canChange, onSaved }) => {
  const current = mapping.result_rule
  const unavailable = current === null
  const [choice, updateChoice] = useState(current || 'best')
  const [busy, updateBusy] = useState(false)
  const [error, updateError] = useState(null)
  const [saved, updateSaved] = useState(false)
  useEffect(() => {
    updateChoice(current || 'best')
  }, [current])

  const disabled = unavailable || !canChange || busy
  const fieldError = error && error.details && error.details.fields && error.details.fields.result_rule
  const id = connection.id

  const save = async () => {
    if (busy || choice === current) return
    updateBusy(true)
    updateError(null)
    updateSaved(false)
    try {
      await lmsAdmin.setCourseResultRule(id, Number(nodeId), choice)
      updateSaved(true)
      if (onSaved) await onSaved()
    } catch (e) {
      updateError(e)
    }
    updateBusy(false)
  }

  return (
    <div className="mt-2" data-testid={`result-rule-${id}`}>
      <div className="fw-semibold">{RESULT_RULE_TITLE}</div>
      <div className="radio-group my-2" role="radiogroup" aria-label={RESULT_RULE_TITLE}>
        {RESULT_RULES.map(rule => (
          <label key={rule.value} className={`radio-option ${choice === rule.value ? 'selected' : ''}`}>
            <input
              type="radio"
              name={`result-rule-${id}`}
              value={rule.value}
              checked={choice === rule.value}
              disabled={disabled}
              data-testid={`result-rule-${id}-${rule.value}`}
              onChange={() => {
                updateChoice(rule.value)
                updateSaved(false)
              }}
            />
            <div className="body">
              <div className="name">{rule.value === 'best' ? 'Best (default)' : rule.label}</div>
              <div className="desc">{rule.desc}</div>
            </div>
          </label>
        ))}
      </div>
      <div className="field-help" data-testid={`result-rule-help-${id}`}>
        {RESULT_RULE_HELP}
      </div>
      {unavailable && (
        <div className="field-help text-muted" data-testid={`result-rule-unavailable-${id}`}>
          {RESULT_RULE_UNAVAILABLE}
        </div>
      )}
      {error && (
        <div className="alert alert-danger py-1 mt-2" role="alert" data-testid={`result-rule-error-${id}`}>
          {fieldError || error.message}
        </div>
      )}
      {saved && !error && (
        <div className="text-success small mt-1" role="status" data-testid={`result-rule-saved-${id}`}>
          Saved.
        </div>
      )}
      {canChange && !unavailable && (
        <button
          className="btn btn-light border btn-sm mt-2"
          type="button"
          disabled={busy || choice === current}
          data-testid={`result-rule-save-${id}`}
          onClick={save}
        >
          Save
        </button>
      )}
    </div>
  )
}
